import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Bot, LogOut, User, LayoutDashboard } from 'lucide-react';

const Header = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <Bot size={32} style={{ display: 'inline', marginRight: '0.5rem' }} />
            AI Agents Platform
          </Link>

          <nav className="nav">
            {!user ? (
              <>
                <Link to="/">Home</Link>
                <Link to="/pricing">Prezzi</Link>
                <Link to="/login">Accedi</Link>
                <Link to="/register" className="btn btn-primary">
                  Inizia Ora
                </Link>
              </>
            ) : (
              <>
                <Link to="/dashboard">
                  <LayoutDashboard size={18} style={{ display: 'inline', marginRight: '0.25rem' }} />
                  Dashboard
                </Link>
                {isAdmin() && (
                  <Link to="/admin">
                    <User size={18} style={{ display: 'inline', marginRight: '0.25rem' }} />
                    Admin
                  </Link>
                )}
                <span style={{ color: 'var(--gray)' }}>
                  Ciao, {user.name}
                </span>
                <button onClick={handleLogout} className="btn btn-outline">
                  <LogOut size={18} />
                  Esci
                </button>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
